var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignDrawing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96002 8.95996H46.08V51.2H8.96002V8.95996Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.08 10.2402H15.36V49.9202H14.08V10.2402ZM19.2 10.2402H20.48V49.9202H19.2V10.2402ZM24.32 10.2402H25.6V49.9202H24.32V10.2402ZM29.44 10.2402H30.72V49.9202H29.44V10.2402ZM34.56 10.2402H35.84V49.9202H34.56V10.2402ZM39.68 10.2402H40.96V49.9202H39.68V10.2402Z",
    fill: "#42A5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 14.0801H44.8V15.3601H10.24V14.0801ZM10.24 19.2001H44.8V20.4801H10.24V19.2001ZM10.24 24.3201H44.8V25.6001H10.24V24.3201ZM10.24 29.4401H44.8V30.7201H10.24V29.4401ZM10.24 34.5601H44.8V35.8401H10.24V34.5601ZM10.24 39.6801H44.8V40.9601H10.24V39.6801ZM10.24 44.8001H44.8V46.0801H10.24V44.8001Z",
    fill: "#42A5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 51.1998V19.4199L45.5501 19.9498L18.1402 47.3598L21.9802 51.1998H46.08Z",
    fill: "#1565C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 51.1999V38.3999L33.28 51.1999H36.8999H46.08Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7599 47.3599L47.3593 21.7597L55.0391 29.4393L29.4398 55.0395L21.7599 47.3599Z",
    fill: "#FFA000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0657 24.0542L47.3855 26.374L45.5752 28.1842L43.2555 25.8644L45.0657 24.0542Z",
    fill: "#9E6400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8245 32.7744L43.0144 34.5846L38.7739 30.3443L40.5841 28.5341L44.8245 32.7744Z",
    fill: "#9E6400"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8645 41.7344L34.0543 43.5446L29.8139 39.3043L31.6241 37.4941L35.8645 41.7344Z",
    fill: "#9E6400"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4642 44.2939L27.654 46.1042L25.3342 43.7844L27.1444 41.9742L29.4642 44.2939Z",
    fill: "#9E6400"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4242 35.334L36.614 37.1442L34.2942 34.8245L36.1044 33.0143L38.4242 35.334Z",
    fill: "#9E6400"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9501 45.5499L19.2 46.3V48.4197L19.9501 49.1697L20.48 49.6997V46.0798H23.04L24.32 44.7998H20.7002L19.9501 45.5499ZM34.56 49.9198H35.84V48.6398L34.56 49.9198ZM44.8 40.9598V39.6798L43.52 40.9598H44.8ZM40.96 49.9198V46.0798H44.8V44.7998H40.96V43.5198L38.4 46.0798H39.68V49.9198H40.96ZM24.32 41.18V44.7998L25.6 43.5198V40.9598H28.16L29.44 39.6798H25.8202L24.32 41.18ZM34.56 30.94V34.5598L35.84 33.2798V30.7198H38.4L39.68 29.4398H36.0602L34.56 30.94ZM29.44 36.06V39.6798L30.72 38.3998V35.8398H33.28L34.56 34.5598H30.9402L29.44 36.06ZM39.68 25.82V29.4398L40.96 28.1598V25.5998H43.52L44.8 24.3198H41.1802L39.68 25.82Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignDrawing);
export default __webpack_public_path__ + "static/media/design-drawing.3cb9da448f8424c7bf2ef0f6aa06b2af.svg";
export { ForwardRef as ReactComponent };